import GroupManagerWindow from '../components/Groups';

const GroupManagerPage = () => {

  return (
    <div className="flex flex-col max-w-full p-4">
      <GroupManagerWindow />
    </div>
  );
};

export default GroupManagerPage;
